<div class="switch-input" [ngClass]="{ active: on }" (click)="toggleState()">
  <div class="label">{{ translator.translate(labelState()) | async }}</div>
  <div class="switch">
    <div class="pointer"></div>
  </div>
  <input type="radio" name="radioInput" id="radioInput" [defaultChecked]="on" />
</div>
